import { entryFromExport } from "@lexireveal/content-schema";
import type { ContentEntry } from "@lexireveal/content-schema";
import { appeler } from "./supabase";

/**
 * Le corpus publié, gardé le temps de la session : il sert à chercher les
 * couples confondables pendant qu'on écrit, et 1 500 entrées ne se
 * retéléchargent pas à chaque lettre tapée. Oublié après chaque écriture.
 */

let enCours: Promise<readonly ContentEntry[]> | null = null;

export function chargerCorpus(): Promise<readonly ContentEntry[]> {
  enCours ??= appeler<unknown[]>("exporter_corpus")
    .then((lignes) => lignes.map(entryFromExport))
    .catch((erreur: unknown) => {
      enCours = null;
      throw erreur;
    });
  return enCours;
}

export function oublierCorpus(): void {
  enCours = null;
}
